/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-script-url */
import React from "react";
import PropTypes from "prop-types";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import styled from "styled-components";

export const Wrapper = styled.section`
  margin-bottom: 10px;
  .navigation {
    float: right;
    list-style: none;
    margin: 0;
    background-color: #ccc;
    padding: 10px;
    border: 1px solid #999;
    font-size: 12px;
  }
  .subhead-page {
    font-size: 16px;
    display: block;
    margin-top: 6px;
  }
`;

const MessageBoardHeader = (props) => {
  return (
    <Wrapper>
      <Row>
        <Col xs={12} sm={6}>
          <h1 className="page-header">Message Board: {props.children}</h1>
        </Col>
        <Col xs={12} sm={6}>
          {props.menu && (
            <div className="header-right">
              <ul className="navigation">
                <li>
                  <Link to="/message-board/today">
                    <FontAwesomeIcon icon="calendar" className="cubes fa mr fa-calendar" />
                  </Link>
                  <Link to="/message-board/today">Today's Messages</Link>
                </li>
                <li>
                  <a href="javascript:;" onClick={props.checkRecent}>
                    <FontAwesomeIcon icon="sync" className="cubes fa mr fa-sync" />
                  </a>
                  <a href="javascript:;" onClick={props.checkRecent}>
                    Check for new topics
                  </a>
                </li>
                <li>
                  <Link to="/message-board/new">
                    <FontAwesomeIcon icon="comment" className="cubes fa mr fa-comment" />
                  </Link>
                  <Link to="/message-board/new">Start New Topic</Link>
                </li>
              </ul>
            </div>
          )}
        </Col>
      </Row>
    </Wrapper>
  );
};

MessageBoardHeader.propTypes = {
  menu: PropTypes.bool,
};

MessageBoardHeader.defaultProps = {
  menu: true,
};

export default MessageBoardHeader;
